import { render } from "./UserLogin.vue?vue&type=template&id=4364dafe"
import script from "./UserLogin.vue?vue&type=script&lang=js"
export * from "./UserLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__